import { Pipe, PipeTransform, SecurityContext, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'htmlSanitize', standalone: true })
export class HtmlSanitizePipe implements PipeTransform {
  private sanitizer = inject(DomSanitizer);


  transform(value: string, ...args: unknown[]): string | null {
    return this.sanitizer.sanitize(SecurityContext.HTML, value);
  }
}
